<ng-container *ngIf="responsive; else chips">
  <div class="d-none d-lg-block">
    <ng-container *ngTemplateOutlet="chips"></ng-container>
  </div>

  <f-dropdown
    class="d-lg-none"
    [ngClass]="dropdownCssClass"
    [disabled]="disabled"
    [btnStyle]="btnStyle"
    [iconAfterTitle]="iconAfterTitle"
    [iconPopoverContent]="iconPopoverContent"
    [placement]="dropdownPlacement"
    [text]="selectedItem | fNestedValue : valuePath"
  >
    <f-list>
      <f-list-item fDropdownItem *ngFor="let item of items" (click)="onSelect(item)">
        {{ item | fNestedValue : valuePath }}
      </f-list-item>
    </f-list>
  </f-dropdown>
</ng-container>

<ng-template #chips>
  <f-chip
    *ngFor="let item of items; let lastItem = last"
    [class.me-1]="!lastItem"
    [class.d-inline-flex]="chipSize === ChipSize.Xxs"
    [size]="chipSize"
    [disabled]="disabled"
    [type]="getChipType(item)"
    [rootCssClass]="rootCssClass"
    [outline]="outline"
    (chipClick)="onSelect(item)"
    [attr.data-automation-id]="'single-choice-chip-' + item[idField]"
  >
    {{ item | fNestedValue : valuePath }}
    <i
      *ngIf="item.hasIcon"
      class="f-i f-i-info"
      [triggers]="popoverTriggers"
      container="body"
      [ngbPopover]="$any(item.iconPopoverContent)"
      [mobilePopoverTitle]="$any(item.text)"
      placement="top"
      fMobilePopover
    ></i>
  </f-chip>
</ng-template>
